import type { ToolCallMessagePartProps } from '@assistant-ui/react';
import { useNamespaceCopy } from '@/i18n/ns';
import renderKitCopy from '@/i18n/ns/render-kit';
import { isActionPointer } from '@/components/assistant-ui/action-confirmation';
import { EmailCard } from './email-card';
import { EmailThreadCard } from './email-thread-card';
import { EmailDraftCard } from './email-draft-card';
import { emailThreadView, emailView } from './email-model';

type Props = ToolCallMessagePartProps & { messageId: string; fresh: boolean };

/** One render_* tool call: its card, or one quiet line while it loads or when it cannot show. */
export function RenderToolPart({ toolName, toolCallId, result, messageId, fresh }: Props) {
  const copy = useNamespaceCopy(renderKitCopy);
  if (result === undefined)
    return (
      <section className="pc-action-status-line" role="status" aria-busy="true">
        {copy.loading}
      </section>
    );
  if (toolName === 'render_email_draft' && isActionPointer(result))
    return <EmailDraftCard pointer={result} fresh={fresh} origin={{ messageId, toolCallId }} />;
  const output = result as { status?: string; email?: unknown; thread?: unknown };
  const email = toolName === 'render_email' && output?.status === 'ok' && emailView(output.email);
  if (email) return <EmailCard email={email} />;
  const thread =
    toolName === 'render_email_thread' && output?.status === 'ok' && emailThreadView(output.thread);
  if (thread) return <EmailThreadCard thread={thread} />;
  // The assistant explains a failed read in its answer; the card says only that it is absent.
  return (
    <section className="pc-action-status-line" role="status">
      {copy.unavailable}
    </section>
  );
}
